module.exports = __webpack_public_path__ + "static/media/measurementReport.ab893ee1.png";